import React from "react";

function getOperationBadgeLabel(operation) {
    if (operation === "운영업체") {
        return "운영";
    }
    if (operation === "일반업체") {
        return "일반";
    }
    return operation;
}

function CompanyManageSidebarList({items = [], selectedId, onSelect}) {
    return (
        <div className="code-manage-item-list company-manage-item-list">
            <p className="code-manage-item-list__heading">업체 목록</p>
            <div className="code-manage-item-list__scroll code-manage-scroll-area company-manage-item-list__scroll">
                {!items?.length ? (
                    <p className="code-manage-item-list__empty">검색 결과가 없습니다.</p>
                ) : (
                    <ul className="sidebar-flat-list company-manage-sidebar">
                        {items.map((item) => {
                            const isSelected = selectedId === item.id;
                            const isOperating = item.operation === "운영업체";

                            return (
                                <li
                                    key={item.id}
                                    className={`sidebar-flat-list__item company-manage-sidebar__item ${isSelected ? "is-selected" : ""}`}
                                >
                                    <button
                                        type="button"
                                        className="sidebar-flat-list__label"
                                        onClick={() => onSelect(item)}
                                    >
                                        <span className="sidebar-flat-list__name">{item.name}</span>
                                        {item.operation && (
                                            <span className={`company-manage-sidebar__badge ${isOperating ? "is-active" : "is-inactive"}`}>
                                                {getOperationBadgeLabel(item.operation)}
                                            </span>
                                        )}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default CompanyManageSidebarList;
